import React, { useState } from "react";
import styles from "../../../../styles/pages/user/memberpartner/memberpartner-pending-video.module.scss";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  List,
  ListItem,
  Paper,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  tooltipClasses,
} from "@mui/material";
import videoPage from "../../../../public/assets/images/videoImage.png";
import CopyLinkIcon from "../../../../public/assets/icons/CopyLinkIcon";
// import VideoButtonGroup from "../VideoButtonGroup/VideoButtonGroup";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import VideoUpbuttonOptionPending from "../VideoUpbuttonOption/VideoUpbuttonOptionPending";
// import DownloadVideoIcon from "../../ui/Icons/DownloadVideoIcon";
import CopyIndexIcon from "../../../../public/assets/icons/CopyIndexIcon";
import VideoUrlIcon from "../../../../public/assets/icons/VideoUrlIcon";
import TextZoomIcon from "../../../../public/assets/icons/TextZoomIcon";
import { styled } from "@mui/system";
import FileAttachIcon from "../../../../public/assets/icons/FileAttachIcon";
import SolidCrrossIcon from "../../../../public/assets/icons/SolidCrrossIcon";
import noteIcon from "../../../../public/assets/images/noteIcon.svg";
import noteDateIcon from "../../../../public/assets/images/noteDateIcon.svg";
import noteDeleteIcon from "../../../../public/assets/images/noteDeleteIcon.svg";
import noteEyeIcon from "../../../../public/assets/images/noteEyeIcon.svg";
import VideoButtonGroup from "../../../../components/VideoButtonGroup/VideoButtonGroup";
import VideoUpbuttonOptionPending from "../../../../components/VideoUpbuttonOption/VideoUpbuttonOptionPending";
import DownloadVideoIcon from "../../../../public/assets/icons/DownloadVideoIcon";
import ModalWrapperBig from "../../../../ui/ModalWrapper/ModalWrapperBig";
import attachIcon from "../../../../public/assets/images/attachIcon.svg";
import DownArrowBlue from "../../../../ui/Icons/DownArrowBlue";
import VISDaccordian from "../../../../components/MemberPartnerVideoDetails/VidsAccordian";
import TabPanel from "../../../../components/UtilitiesComponent/TabPanel";

const MemberPartnerPendingVideoPage = () => {
  const OriginalVideoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} followCursor />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#fff",
      maxWidth: 237,
      borderRadius: "10px",
      color: "#000",
      boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
      padding: "9px 13px",
      [`& p`]: {
        color: "#000",
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "14px",
      },
    },
  }));

  const SocialVideoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} followCursor />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#fff",
      maxWidth: 237,
      borderRadius: "10px",
      color: "#000",
      boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
      padding: "9px 13px",
      [`& p`]: {
        color: "#000",
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "14px",
      },
    },
  }));
  const [expanded, setExpanded] = React.useState(false);
  const [saved, setsaved] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [linkButton, setlinkButton] = useState({ youtube: false, post: false });
  const [Open1, setOpen1] = useState(false);
  const [videoRemoved, setvideoRemoved] = useState(false);
  const [ViewMessege, setViewMessege] = useState(false);
  const [noteSaved, setnoteSaved] = useState(false);
  const [noteSavedLoading, setnoteSavedLoading] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleClickOpen1 = () => {
    setOpen1(true);
  };
  const handleClose1 = () => {
    setOpen1(false);
  };

  const handleClose = () => {
    setnoteSavedLoading(false);
  };
  const handleOpen = () => {
    setOpen(true);
    setTimeout(() => {
      setsaved(true);
    }, 2000);
  };

  const handleSave = () => {
    setOpen1(false);
    setnoteSavedLoading(true);
    setTimeout(() => {
      setnoteSavedLoading(false);
      setnoteSaved(true);
    }, 2000);
  };

  const handleMessegeDelete = () => {
    setnoteSaved(false);
  };
  const handleMessegeOpen = () => {
    setViewMessege(true);
  };
  const handleMessegeClose = () => {
    setViewMessege(false);
  };

  const [tabValue, setTabValue] = React.useState(0);
  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const [value, setValue] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const ownershipdata = [
    {
      head: "The Person Who Filmed This Video  Is ",
      content: "Me",
    },
    {
      head: "Are There People Appearing In the Video?  ",
      content: "No",
    },
    {
      head: "Did You Send/Submit/Upload This Video To A Website And/Or Social Media Account?   ",
      content: "Yes, a YouTube account",
    },
    {
      head: "Did Anyone Reach You About Using This Video?   ",
      content: "Yes, another company contacted me",
    },
    {
      head: "Did You Sign A Licensing Agreement For This Video With Another Company/Page?   ",
      content: "Yes, I Have Signed An Exclusive Agreement",
    },
  ];

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const PostInfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#fff",
      maxWidth: 199,
      borderRadius: "10px 10px 0 10px",
      color: "#000",
      boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
      padding: "10px",
      margin: "0 !important",
    },
  }));
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const dialogContainer = {
    [`.MuiDialog-container`]: {
      alignItems: "flex-start",

      [`.MuiDialog-paper`]: {
        marginTop: "62px",
        boxShadow: "none",
        borderRadius: "10px !important",
        [`.MuiDialogContent-root`]: {
          padding: "0",
        },
      },
    },
  };
  return (
    <Box className={styles.publishVideoPage}>
      <PerfectScrollbar className={styles.editorPublishScroll}>
        <Box className={styles.videoPageMain}>
          <Box className={styles.videoPageMainLeft}>
            <Box
              className={`${styles.videosection} ${videoRemoved && styles.videoRemoved
                }`}
            >
              <Box className={styles.videoSectionvideo}>
                <img src={videoPage} alt="" />
                <VideoUpbuttonOptionPending />
              </Box>

              <Box className={styles.videoLink}>
                <input
                  type="text"
                  placeholder="https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                />
                <Button>
                  <CopyLinkIcon />
                </Button>
              </Box>

              <Box className={styles.videoButtonGroup}>
                <VideoButtonGroup />
              </Box>

              <Box className={styles.downloadVideo}>
                <Button>
                  <DownloadVideoIcon /> Download Video
                </Button>
                {/* <Button className={styles.confirmBtn} onClick={handleOpen}><RightBlackIcon /> Confirm Update</Button> */}
              </Box>
            </Box>
            {videoRemoved && (
              <Box className={`${styles.purchedBox} ${styles.greenBox}`}>
                <p>
                  Video pending titling since January 22, 2023 at 07:56 PM UTC.
                </p>
              </Box>
            )}
            <Paper
              className={`${styles.comWhiteBox} ${styles.titlePaperBox} ${videoRemoved && styles.videoRemoved
                } ${styles.vdoDetailsCard}`}
            >
              <Box className={styles.paperHeading}>
                <Typography variant="h2">
                  <span>Video Details</span>
                </Typography>
              </Box>
              <Box className={styles.vdodetailInner}>
                <Box className={styles.vdoUrlGroup}>
                  <Typography variant="caption" className={styles.formLabel}>
                    Public Post URL
                  </Typography>
                  <Box className={styles.videoInput}>
                    <input
                      type="text"
                      placeholder="Https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                    />
                    <Button>
                      <CopyIndexIcon />
                    </Button>
                  </Box>
                </Box>
                <Box className={styles.titleGroup}>
                  <Typography variant="caption" className={styles.formLabel}>
                    Title
                  </Typography>
                  <Typography variant="body2" className={styles.formPara}>
                    Boy Jumped with the Umbrella and the Wind Almost Sent Him
                    Flying Too Far Away
                  </Typography>
                </Box>
                <Box className={styles.descriptionGroup}>
                  <Typography variant="caption" className={styles.formLabel}>
                    Description:
                  </Typography>
                  <Typography variant="body2" className={styles.formPara}>
                    Fusce eget lacus non turpis porttitor gravida sit amet quis
                    tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis
                    purus nisl, eu elementum risus faucibus vitae.
                    Integmolestie, ex sit amet semd mauris odimolestie, met semd
                    mauris odimolestie, ex sit amet semd maurier molestie, ex
                    sit amet semd mauris odidgfgo...{" "}
                    <Button>
                      <TextZoomIcon />
                    </Button>
                  </Typography>
                </Box>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  className={styles.filmingGrid}
                >
                  <Box className={`${styles.filmingLocaton} ${styles.Col}`}>
                    <Typography variant="caption" className={styles.formLabel}>
                      Filming Location
                    </Typography>
                    <Typography variant="body2" className={styles.formPara}>
                      Los Angeles, California, United States
                    </Typography>
                  </Box>
                  <Box className={`${styles.filmingDate} ${styles.Col}`}>
                    <Typography variant="caption" className={styles.formLabel}>
                      Filming Date
                    </Typography>
                    <Typography variant="body2" className={styles.formPara}>
                      January 25, 2019
                    </Typography>
                  </Box>
                </Stack>
              </Box>
              {/* <Box className={styles.vdoFileList}>
                                    <InputLabel>Original Video File(s)</InputLabel>
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                        <Box className={styles.linkBox}>
                                            <Typography variant='caption'>1.</Typography>
                                            <input type='text' value={value} onChange={(e) => setValue(e.target.value)} />
                                        </Box>
                                        <ButtonGroup>
                                            <Button onClick={addList}><AddPlusIcon /></Button>
                                            <PostInfoTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Box className={styles.infoTooltip}>
                                                            <List disablePadding>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Added by:</InputLabel>
                                                                    <Typography variant='body2'>Partner/QC Agent/Member/Manager</Typography>
                                                                </ListItem>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Date:</InputLabel>
                                                                    <Typography variant='body2'>January 22, 2021 at 07:45 AM UTC</Typography>
                                                                </ListItem>
                                                            </List>
                                                        </Box>
                                                    </React.Fragment>
                                                }
                                            >
                                                <figure><InfoIcon /></figure>
                                            </PostInfoTooltip>
                                        </ButtonGroup>
                                    </Stack>
                                    <List disablePadding>
                                        {lisitem.map((data, index) => (
                                            <ListItem disablePadding key={index}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                                    <Box className={styles.linkBox}>
                                                        <Typography variant='caption'>1.</Typography>
                                                        <input type='text' disabled {...data} />
                                                    </Box>
                                                    <ButtonGroup>
                                                        <Button>
                                                            <BtnTickIcon />
                                                        </Button>
                                                        <Button onClick={() => removeItem(index)}>
                                                            <BtnCrossIcon />
                                                        </Button>
                                                    </ButtonGroup>
                                                </Stack>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box> */}
              {/* <Box className={styles.vdoFileList}>
                                    <InputLabel>Social Media Post(s)</InputLabel>
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                        <Box className={styles.linkBox}>
                                            <Typography variant='caption'>1.</Typography>
                                            <input type='text' value={socialValue} onChange={(e) => setsocialValue(e.target.value)} />
                                        </Box>
                                        <ButtonGroup>
                                            <Button onClick={addListsocial}><AddPlusIcon /></Button>
                                            <PostInfoTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Box className={styles.infoTooltip}>
                                                            <List disablePadding>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Added by:</InputLabel>
                                                                    <Typography variant='body2'>Partner/QC Agent/Member/Manager</Typography>
                                                                </ListItem>
                                                                <ListItem disablePadding>
                                                                    <InputLabel>Date:</InputLabel>
                                                                    <Typography variant='body2'>January 22, 2021 at 07:45 AM UTC</Typography>
                                                                </ListItem>
                                                            </List>
                                                        </Box>
                                                    </React.Fragment>
                                                }
                                            >
                                                <figure><InfoIcon /></figure>
                                            </PostInfoTooltip>
                                        </ButtonGroup>
                                    </Stack>
                                    <List disablePadding>
                                        {socialLisitem.map((data, index) => (
                                            <ListItem disablePadding key={index}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.addVdoFile}>
                                                    <Box className={styles.linkBox}>
                                                        <Typography variant='caption'>1.</Typography>
                                                        <input type='text' disabled {...data} />
                                                    </Box>
                                                    <ButtonGroup>
                                                        <Button>
                                                            <BtnTickIcon />
                                                        </Button>
                                                        <Button onClick={() => removeItemsocial(index)}>
                                                            <BtnCrossIcon />
                                                        </Button>
                                                    </ButtonGroup>
                                                </Stack>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box> */}
              <Box className={styles.mediaFilebtn}>
                <OriginalVideoTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit">
                        Partner is currently adding a file.
                        <br /> Please try again in a few minutes.
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <Button startIcon={<VideoUrlIcon />}>
                    Add original video file (VS Link)
                  </Button>
                </OriginalVideoTooltip>
              </Box>
              <Box className={styles.mediaFilebtn}>
                <SocialVideoTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit">
                        Partner is adding a post URL.
                        <br /> Please try again in a few minutes.
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <Button startIcon={<FileAttachIcon />}>
                    Add social media post URL
                  </Button>
                </SocialVideoTooltip>
              </Box>
            </Paper>
          </Box>

          <Box className={`${styles.videoColRight} `}>
            <Box className={styles.cmnboxborderd}>
              <Box
                className={`${styles.pageMainAlert} ${styles.pageMainAlertTwo}`}
              >
                <Typography variant="body1">
                  This video is <strong> Pending</strong> review
                </Typography>

                <Button className={styles.btnClose}>
                  <SolidCrrossIcon />
                </Button>
              </Box>
            </Box>
            <VISDaccordian />
            <Paper
              className={`${styles.comWhiteBox} ${styles.submitterDetails} ${styles.videoRemoved}`}
            >
              <Box className={styles.paperHeading}>
                <Typography variant="h2">
                  <span>Submitter Details</span>
                </Typography>
              </Box>
              <Stack
                direction={"row"}
                flexWrap={"wrap"}
                className={styles.ownerDetailsGrid}
              >
                <Box className={`${styles.gridCol1} ${styles.Col1}`}>
                  <Box className={`${styles.formGroup} ${styles.formName}`}>
                    <Typography variant="h6">Full Name</Typography>
                    <Typography variant="body2">Saimon Jhonson</Typography>
                  </Box>
                  <Box className={`${styles.formGroup} ${styles.formSocial}`}>
                    <Typography variant="h6">Social Media Handles</Typography>
                    <Typography variant="body2">Saimon Jhonson</Typography>
                  </Box>
                </Box>
                <Box className={`${styles.gridCol2} ${styles.Col1}`}>
                  <Box className={`${styles.formGroup} ${styles.formEmail}`}>
                    <Typography variant="h6">Email Address</Typography>
                    <Typography variant="body2" classname={styles.mailadd}>
                      jognsmith@gmail.com
                    </Typography>
                  </Box>
                </Box>
                <Box className={`${styles.gridCol3} ${styles.Col1}`}>
                  <Box className={`${styles.formGroup} ${styles.formDob}`}>
                    <Typography variant="h6">Date Of Birth</Typography>
                    <Typography variant="body2">05/17/2002</Typography>
                  </Box>
                </Box>
              </Stack>
            </Paper>
            <Box
              className={`${styles.VideocommonBox} ${styles.VideocommonBoxError}`}
            >
              <Box
                className={`${styles.ownerDetails} ${styles.ownerDetailsError}`}
              >
                <Box className={styles.copyright_head_box}>
                  <Typography variant="h5" className={styles.copy_heading}>
                    Copyrights Ownership
                  </Typography>
                </Box>
                <Box
                  className={`${styles.copyRightTxt} ${styles.copyRightTxtError}`}
                >
                  <List>
                    <ListItem>
                      <Box className={styles.copyRighttxtBox}>
                        <h4>The Person Who Filmed This Video Is</h4>
                        <h5>Me</h5>
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box
                        className={`${styles.copyRighttxtBox} ${styles.copyRighttxtBoxOrange}`}
                      >
                        <h4>Are There People Appearing In the Video? </h4>
                        <h5>Yes</h5>
                      </Box>

                      <Box
                        className={`${styles.copyRighttxtBox} ${styles.copyRighttxtBoxOrange}`}
                      >
                        <h4>Who are they?</h4>
                        <h5>my friends</h5>
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box
                        className={`${styles.copyRighttxtBox} ${styles.copyRighttxtBoxRed}`}
                      >
                        <h4>
                          Did You Send/Submit/Upload This Video To A Website
                          And/Or Social Media Account?{" "}
                        </h4>
                        <h5>Yes, a YouTube account</h5>
                      </Box>

                      <Box
                        className={`${styles.copyRighttxtBox} ${styles.copyRighttxtBoxRed}`}
                      >
                        <h4>Where Did You Submit It?</h4>
                        <h5>Instagram, Facebook, Tic Tok, it may possibly be in an upcoming YouTube video</h5>
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box
                        className={`${styles.copyRighttxtBox} ${styles.copyRighttxtBoxOrange}`}
                      >
                        <h4>Did Anyone Reach You About Using This Video?</h4>
                        <h5>Yes, another company contacted me</h5>
                      </Box>

                      <Box
                        className={`${styles.copyRighttxtBox} ${styles.copyRighttxtBoxOrange}`}
                      >
                        <h4>
                          Please share the name of the company/page with us
                        </h4>
                        <h5>Viralhog, jukin</h5>
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box
                        className={`${styles.copyRighttxtBox} ${styles.copyRighttxtBoxRed}`}
                      >
                        <h4>
                          Did You Sign A Licensing Agreement For This Video With
                          Another Company/Page?
                        </h4>
                        <h5>Yes, I Have Signed An Exclusive Agreement</h5>
                      </Box>

                      <Box
                        className={`${styles.copyRighttxtBox} ${styles.copyRighttxtBoxRed}`}
                      >
                        <h4>Name of the company/page?</h4>
                        <h5>Company Name</h5>
                      </Box>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Box>
            <Paper
              className={`${styles.comWhiteBox} ${styles.submissionInfo} ${videoRemoved && styles.videoRemoved
                }`}
            >
              <Box className={styles.paperHeading}>
                <Typography variant="h2">
                  <span>Submission Information</span>
                </Typography>
              </Box>
              <Stack
                direction={"row"}
                flexWrap={"wrap"}
                className={styles.ownerDetailsGrid}
              >
                <Box className={`${styles.gridCol1} ${styles.Col1}`}>
                  <Box className={`${styles.formGroup} ${styles.formDate}`}>
                    <Typography variant="h6">Submission Date</Typography>
                    <Typography variant="body2">
                      August 23, 2021 at 11:15:34 PM UTC
                    </Typography>
                  </Box>
                  <Box className={`${styles.formGroup} ${styles.formName}`}>
                    <Typography variant="h6">Terms of Submission</Typography>
                    <Typography variant="body2">
                      Agreed | Exclusive License
                    </Typography>
                  </Box>
                </Box>
                <Box className={`${styles.gridCol2} ${styles.Col1}`}>
                  <Box className={`${styles.formGroup} ${styles.formRevenue}`}>
                    <Typography variant="h6">Revenue Share:</Typography>
                    <Typography variant="body2">50%</Typography>
                  </Box>
                  <Box className={`${styles.formGroup} ${styles.formTerms}`}>
                    <Typography variant="h6">Terms of Service</Typography>
                    <Typography variant="body2">Agreed</Typography>
                  </Box>
                </Box>
                <Box className={`${styles.gridCol3} ${styles.Col1}`}>
                  <Box className={`${styles.formGroup} ${styles.formVsid}`}>
                    <Typography variant="h6">VSID</Typography>
                    <Typography variant="body2">17171</Typography>
                  </Box>
                </Box>
              </Stack>
            </Paper>

            <Box className={styles.commonAccordianWrapper}>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={styles.teamAccordianHeader}
                >
                  <Box
                    className={`${styles.accordianHeader} ${styles.accordianHeaderTwo} `}
                  >
                    <Typography variant="body1">
                      {" "}
                      <span>Team Messages</span>
                    </Typography>
                    <Box className={`${styles.btnGroup} ${styles.btnGroupTwo}`}>
                      <Button>Partner</Button>
                      <Button>Manager</Button>
                      <Button>QC Agent</Button>
                    </Box>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Box className={styles.accordianTeamBox}>
                    <Box sx={{ width: "100%" }} className={styles.btnGroup}>
                      <Box className={styles.tabButton}>
                        <Box className={styles.tabButtonGroup}>
                          <Tabs
                            value={value}
                            onChange={handleTabChange}
                            aria-label="basic tabs example"
                          >
                            <Tab label="Partner" />
                            <Tab label="Manager" className={styles.active} />
                            <Tab label="QC Agent" />
                          </Tabs>
                        </Box>
                        <Button className={styles.responsBtn}>
                          Respond Now
                        </Button>
                      </Box>
                      <TabPanel value={value} index={0}>
                        <Typography variant="body1" className={styles.tabContent}>
                          Fusce eget lacus non turpis porttitor gravida sit amet
                          quis tellus. Morbi tempus finibus elit in ultrices.
                          Nunc sagittis purus nisl, eu elementum risus faucibus
                          vita. Integer molestie, ex sit amet semper aliquam,
                          mauris odio dignissim velit, suscipit feugiat massa
                          est varius lectus. Phasellus euismod lacinia tortor ac
                          finibus. Maecenas semper consectetur venenatis. Nullam
                          eget felis gravida, consectetur lacus nec, fermentum
                          metus. Suspendisse ac tellus...
                        </Typography>
                      </TabPanel>
                      <TabPanel value={value} index={1}>
                        <Typography variant="body1" className={styles.tabContent}>
                          Fusce eget lacus non turpis porttitor gravida sit amet
                          quis tellus. Morbi tempus finibus elit in ultrices.
                          Nunc sagittis purus nisl, eu elementum risus faucibus
                          vita. Integer molestie, ex sit amet semper aliquam,
                          mauris odio dignissim velit, suscipit feugiat massa
                          est varius lectus. Phasellus euismod lacinia tortor ac
                          finibus. Maecenas semper consectetur venenatis. Nullam
                          eget felis gravida, consectetur lacus nec, fermentum
                          metus. Suspendisse ac tellus...
                        </Typography>
                        <Box className={`${styles.attachFiles} ${styles.filesWrapper}`}>
                          <Typography variant="caption">
                            Attached files:
                          </Typography>
                          <Typography variant="body1">
                            <DownArrowBlue />{" "}
                            <span> 5028537_5563370603774986.png</span>
                          </Typography>
                        </Box>
                      </TabPanel>
                      <TabPanel value={value} index={2}>
                        <Typography variant="body1" className={styles.tabContent}>
                          Fusce eget lacus non turpis porttitor gravida sit amet
                          quis tellus. Morbi tempus finibus elit in ultrices.
                          Nunc sagittis purus nisl, eu elementum risus faucibus
                          vita. Integer molestie, ex sit amet semper aliquam,
                          mauris odio dignissim velit, suscipit feugiat massa
                          est varius lectus. Phasellus euismod lacinia tortor ac
                          finibus. Maecenas semper consectetur venenatis. Nullam
                          eget felis gravida, consectetur lacus nec, fermentum
                          metus. Suspendisse ac tellus...
                        </Typography>
                      </TabPanel>
                    </Box>
                  </Box>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography variant="body1">
                    <span>My Note</span>{" "}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box className={styles.accordianTxt}>
                    {noteSaved ? (
                      <Box className={styles.messegeViewBox}>
                        <Typography variant="body1">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, toSed ut
                          perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, tdsmohas
                          hfdibnf,d hgbdflk,mdffdo...
                        </Typography>
                        <Box className={styles.messegeBottom}>
                          <Button className={styles.notesdate}>
                            <img
                              src={noteDateIcon}
                              width={11}
                              height={11}
                              alt=""
                            />
                            <span>January 25, 2023</span>
                          </Button>
                          <Box className={styles.messegeButtons}>
                            <Button
                              className={`${styles.notesdate} ${styles.deleteButton}`}
                              onClick={handleMessegeDelete}
                            >
                              <img
                                src={noteDeleteIcon}
                                width={11}
                                height={12}
                                alt=""
                              />
                              <span>Delete</span>
                            </Button>
                            <Button
                              onClick={handleMessegeOpen}
                              className={`${styles.notesdate} ${styles.readButton}`}
                            >
                              <img
                                src={noteEyeIcon}
                                width={11}
                                height={9}
                                alt=""
                              />
                              <span>Read</span>
                            </Button>
                          </Box>
                        </Box>

                        <Box className={styles.filesWrapper}>
                          <Typography variant="caption">
                            Attached files:
                          </Typography>
                          <Typography variant="body1">
                            <DownArrowBlue />{" "}
                            <span> 5028537_5563370603774986.png</span>
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <Box className={styles.accordianTxtButton}>
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Button
                              onClick={handleClickOpen1}
                              className={styles.accordianButtonBox}
                            >
                              <img
                                src={noteIcon}
                                width={19}
                                height={18}
                                alt=""
                              />{" "}
                              Leave a note for the team
                            </Button>
                          </AccordionSummary>
                        </Accordion>
                      </Box>
                    )}
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Box>
          </Box>
          <ModalWrapperBig
            open={Open1}
            onClose={handleClose1}
            handleClose={handleClose1}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="videopage_modal"
          >
            <Box className={styles.messageModal}>
              <Box className={styles.messageModalHeader}>
                <h4>Leave a note for the team</h4>
                <p>
                  <span>Date:</span> January 25, 2023 at 09:21 PM UTC
                </p>
              </Box>

              <Box className={styles.messageModalBody}>
                <Box className={styles.messageInput}>
                  <label>
                    Is there something you would like to bring to the team’s
                    attention?
                  </label>
                  <textarea></textarea>
                </Box>

                <Box className="attachFileinput">
                  <input type="file" id="upload" hidden />
                  <label htmlFor="upload">
                    <img src={attachIcon} width={13} height={15} alt="" />{" "}
                    Attach a file
                  </label>
                </Box>
              </Box>

              <Box className={styles.messageModalFooter}>
                <Button className={styles.cancelButton}>Cancel</Button>
                <Button onClick={handleSave} className={styles.active}>
                  Save Now
                </Button>
              </Box>
            </Box>
          </ModalWrapperBig>
          <ModalWrapperBig
            open={ViewMessege}
            onClose={handleMessegeClose}
            handleClose={handleMessegeClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="videopage_modal"
          >
            <Box className={styles.messageModal}>
              <Box className={styles.messageModalHeader}>
                <p>
                  <span>Date:</span> January 25, 2023 at 09:21 PM UTC
                </p>
              </Box>
              <Box className={styles.messageModalBody}>
                <Box
                  className={`${styles.messegeViewBox} ${styles.viewMessegeModal}`}
                >
                  <Typography variant="body1">
                    Sed ut perspiciatis unde omnis iste natus error sit
                    voluptatem accusantium doloremque laudantium, toSed ut
                    perspiciatis unde omnis iste natus error sit voluptatem
                    accusantium doloremque laudantium, tdsmohas hfdibnf,d
                    hgbdflk,mdffdo...
                  </Typography>
                </Box>
              </Box>

              <Box className={styles.messageModalFooter}>
                <Button onClick={handleMessegeClose} className={styles.active}>
                  Close
                </Button>
              </Box>
            </Box>
          </ModalWrapperBig>
        </Box>
      </PerfectScrollbar>

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={noteSavedLoading}
        onClick={handleClose}
        className={styles.backDropBarWrap}
      >
        {noteSavedLoading && (
          <Box className={styles.backDropBar}>
            <CircularProgress color="inherit" />
            <Typography variant="body1">Saving</Typography>
          </Box>
        )}
      </Backdrop>
    </Box>
  );
};

export default MemberPartnerPendingVideoPage;
